import React from 'react';
import { motion } from 'framer-motion';
interface StepIndicatorProps {
  currentPhase: number;
  label: string;
}
export function StepIndicator({
  currentPhase,
  label
}: StepIndicatorProps) {
  const displayTotal = 6;
  if (currentPhase < 1 || currentPhase > 6) return null;
  return <div className="w-full mb-3" data-id="element-1895">
      <div className="flex gap-1 mb-2" data-id="element-1896">
        {Array.from({
        length: displayTotal
      }).map((_, i) => {
        const stepNumber = i + 1;
        let bgColor = 'bg-gray-200';
        if (stepNumber === currentPhase) bgColor = 'bg-yellow-400';else if (stepNumber < currentPhase) bgColor = 'bg-yellow-400';
        return <motion.div key={i} className={`h-1.5 flex-1 rounded-full ${bgColor}`} layout transition={{
          duration: 0.3
        }} data-id="element-1897" />;
      })}
      </div>
      <div className="flex justify-between items-center text-xs font-medium" data-id="element-1898">
        <span className="text-yellow-600 uppercase tracking-wider" data-id="element-1899">
          Phase {currentPhase} of {displayTotal}
        </span>
        <span className="text-gray-500" data-id="element-1900">{label}</span>
      </div>
    </div>;
}